import { render, staticRenderFns } from "./report-tabs.vue?vue&type=template&id=f081b6ac&"
import script from "./report-tabs.vue?vue&type=script&lang=ts&"
export * from "./report-tabs.vue?vue&type=script&lang=ts&"
import style0 from "./report-tabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports